import { render } from "./OnboardingVideoIntro.vue?vue&type=template&id=46cf8b19&scoped=true&ts=true"
import script from "./OnboardingVideoIntro.vue?vue&type=script&lang=ts"
export * from "./OnboardingVideoIntro.vue?vue&type=script&lang=ts"

import "./OnboardingVideoIntro.vue?vue&type=style&index=0&id=46cf8b19&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cf8b19"]])

export default __exports__